import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { isNativeApp } from "@/lib/utils";

const PLAY_URL = "https://play.google.com/store/apps/details?id=com.fripri.app";
const DISMISS_KEY = "fripri_play_banner_dismissed";

export default function PlayStoreBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const isAndroidBrowser = /Android/i.test(navigator.userAgent) && !isNativeApp();
    if (!isAndroidBrowser) return;
    try {
      if (localStorage.getItem(DISMISS_KEY)) return;
    } catch {}
    setVisible(true);
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    setVisible(false);
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch {}
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-black text-white border-t-2 border-[color:var(--color-mint)] p-3 flex items-center gap-3" data-testid="play-store-banner">
      <img src="/icon-192.png" alt="Fripri" className="w-10 h-10 border-2 border-white shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="font-black text-sm leading-tight">L'app Fripri est disponible !</p>
        <p className="text-xs text-white/70">Plus rapide, avec notifications</p>
      </div>
      <a href={PLAY_URL} target="_blank" rel="noopener noreferrer" className="btn btn-mint btn-sm shrink-0" data-testid="play-store-install-btn">
        Installer
      </a>
      <button onClick={dismiss} className="p-1 shrink-0" data-testid="play-store-dismiss" aria-label="Fermer">
        <X size={18} />
      </button>
    </div>
  );
}
